import React from 'react'
import { Modal, Button, Icon } from 'antd'

const AudioModeChangeModal = ({
  visible,
  pendingMode,
  currentMode,
  targetHasAudio,
  onCancel,
  onContinue,
  onRegenerate
}) => {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered
      width={520}
      className="voiceover-change-modal"
    >
      <div className="voiceover-change-modal-content">
        <div className="modal-icon-wrapper">
          <Icon type="warning" className="modal-warning-icon" />
        </div>
        <h3 className="modal-title">Change Audio Mode?</h3>
        <p className="modal-description">
          You have already generated audio in{' '}
          <strong>
            {currentMode === 'narration' ? 'Narration' : 'Dialogue'}
          </strong>{' '}
          mode.
          {targetHasAudio ? (
            <>
              If you change to{' '}
              <strong>
                {pendingMode === 'narration' ? 'Narration' : 'Dialogue'}
              </strong>{' '}
              mode, you can either continue with the existing generation or
              regenerate audio.
            </>
          ) : (
            <>
              Since{' '}
              <strong>
                {pendingMode === 'narration' ? 'Narration' : 'Dialogue'}
              </strong>{' '}
              mode audio hasn't been generated yet, you will need to regenerate
              it to continue.
            </>
          )}
          <br />
          <br />
          Please choose how you would like to proceed:
        </p>
        <div className="modal-options">
          {targetHasAudio && (
            <div className="modal-option modal-option--recommended">
              <div className="option-icon option-icon--clone">
                <Icon type="forward" />
              </div>
              <div className="option-content">
                <h4 className="option-title">
                  Continue with Existing
                  <span className="recommended-badge">Recommended</span>
                </h4>
                <p className="option-description">
                  Switch modes but keep your existing generated audio links.
                </p>
              </div>
            </div>
          )}
          <div
            className={`modal-option ${
              !targetHasAudio ? 'modal-option--recommended' : ''
            }`}
          >
            <div
              className={`option-icon ${
                !targetHasAudio ? 'option-icon--clone' : ''
              }`}
            >
              <Icon type="sync" />
            </div>
            <div className="option-content">
              <h4 className="option-title">
                Regenerate Audio
                {!targetHasAudio && (
                  <span className="recommended-badge">Required</span>
                )}
              </h4>
              <p className="option-description">
                Switch modes and clear existing generated audio links to start
                fresh.
                <span className="warning-text">
                  <Icon type="warning" /> Warning: Existing audio links will be
                  removed.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="modal-actions">
          <Button onClick={onCancel} size="large">
            Cancel
          </Button>

          <div className="modal-actions-right">
            <Button
              type={!targetHasAudio ? 'primary' : 'default'}
              onClick={onRegenerate}
              size="large"
              icon="sync"
            >
              Regenerate
            </Button>
            {targetHasAudio && (
              <Button
                type="primary"
                onClick={onContinue}
                size="large"
                icon="forward"
              >
                Continue
              </Button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AudioModeChangeModal
